import { el } from "@dhx/ts-common/dom";
import { IDataViewConfig, DataViewEvents, IDataViewItem } from "../types";
import { DataView } from "../DataView";

export class InputEditor {
	protected _handlers: { [key: string]: (...args) => void };
	protected _mode: boolean;
	protected _config: IDataViewConfig;
	protected _dataView: DataView;
	protected _item: IDataViewItem;
	protected _input: HTMLInputElement;

	constructor(item: IDataViewItem, dataView: DataView) {
		this._dataView = dataView;
		this._config = dataView.config;
		this._item = item;
		this._dataView.events.on(DataViewEvents.focusChange, (index, id) => {
			if (this._mode && id !== this._item.id) {
				this.endEdit();
			}
		});
		this._initHandlers();
	}
	endEdit() {
		if (this._input) {
			const value = this._input.value;
			if (this._dataView.events.fire(DataViewEvents.beforeEditEnd, [value, this._item.id])) {
				this._input.removeEventListener("blur", this._handlers.onBlur);
				this._input.removeEventListener("change", this._handlers.onChange);
				this._input.removeEventListener("keydown", this._handlers.onKeyDown);
				this._handlers = {};
				this._mode = false;

				this._dataView.events.fire(DataViewEvents.afterEditEnd, [value, this._item.id]);
			} else {
				this._input.focus();
			}
		}
	}
	toHTML(isLastItemInRow: boolean) {
		this._mode = true;

		const { itemsInRow, gap } = this._config;
		const gapWithPx = (gapSize: any) => parseFloat(gapSize);

		return el(
			".dhx_input__wrapper",
			{
				style: {
					width: `calc(${100 / itemsInRow}% - ${gapWithPx(gap)} * ${(itemsInRow - 1) /
						itemsInRow}px)`,
					maxWidth: `calc(${100 / itemsInRow}% - ${gapWithPx(gap)} * ${(itemsInRow - 1) /
						itemsInRow}px)`,
					marginRight: isLastItemInRow ? "" : gap,
				},
				role: "presentation",
			},
			[
				el(
					"div.dhx_input__container",
					{
						style: {
							height: "100%",
						},
						role: "presentation",
					},
					[
						el("input.dhx_input", {
							class:
								(this._item.css ? " " + this._item.css : "") +
								(isLastItemInRow ? " dhx_dataview-item--last-item-in-row" : ""),
							style: {
								padding: "8px, 12px",
								width: "100%",
								height: "100%",
							},
							_hooks: {
								didInsert: this._handlers.didInsert,
							},
							_key: this._item.id,
							"data-dhx-id": this._item.id,
						}),
					]
				),
			]
		);
	}
	protected _initHandlers() {
		this._handlers = {
			onBlur: () => {
				this.endEdit();
			},
			onChange: () => {
				this.endEdit();
			},
			onKeyDown: (e: KeyboardEvent) => {
				if (e.key === "Enter" && this._item.value === this._input.value) this.endEdit();
				if (e.key === "Escape") {
					this._input.value = this._item.value;
					this.endEdit();
				}
			},
			didInsert: (node: any) => {
				const input = node.el;
				this._input = input;
				input.focus();
				input.value = this._item.value;
				input.setSelectionRange(0, input.value.length);
				input.addEventListener("change", this._handlers.onChange);
				input.addEventListener("blur", this._handlers.onBlur);
				input.addEventListener("keydown", this._handlers.onKeyDown);
			},
		};
	}
}
